import { ProjectDataType } from "@custom-types/project-data-types";

/** True iff the passed value is of type ProjectDataType */
export function isProjectDataType(value: unknown): value is ProjectDataType {
  return (
    typeof value === "string" && Object.keys(ProjectDataType).includes(value)
  );
}
